/**
 * --------------------------------------------------------------------------
 * CoreUI PRO data-grid labels.ts
 * License (https://coreui.io/pro/license/)
 * --------------------------------------------------------------------------
 */

import type { DataGridLabels } from './types'

export const DEFAULT_LABELS: DataGridLabels = {
  addCondition: 'Add condition',
  applyFilter: 'Apply',
  clearFilter: 'Clear filter',
  clearSort: 'Unsort',
  columnMenu: 'Column options for {column}',
  filterAction: 'Filter…',
  filterColumn: 'Filter {column}',
  firstPage: 'First page',
  globalFilterLabel: 'Search',
  globalFilterPlaceholder: 'Search',
  hideColumn: 'Hide column',
  itemsInfo: '{first}–{last} of {total}',
  joinAnd: 'AND',
  joinOr: 'OR',
  lastPage: 'Last page',
  loadError: 'Failed to load data',
  loading: 'Loading…',
  moveEnd: 'Move to end',
  moveStart: 'Move to start',
  nextPage: 'Next page',
  operatorBetween: 'Between',
  operatorBlank: 'Blank',
  operatorContains: 'Contains',
  operatorEndsWith: 'Ends with',
  operatorEquals: 'Equals',
  operatorGreaterThan: 'Greater than',
  operatorGreaterThanOrEqual: 'Greater than or equal',
  operatorLessThan: 'Less than',
  operatorLessThanOrEqual: 'Less than or equal',
  operatorNotBlank: 'Not blank',
  operatorNotContains: 'Does not contain',
  operatorNotEquals: 'Not equals',
  operatorStartsWith: 'Starts with',
  pageSizeLabel: 'Rows per page',
  paginationLabel: 'Pagination',
  pinEnd: 'Pin to end',
  pinStart: 'Pin to start',
  previousPage: 'Previous page',
  redoneAnnouncement: 'Change redone',
  reorderRow: 'Reorder row',
  resetColumns: 'Reset',
  resultsAnnouncement: '{count} results',
  searchValues: 'Search values',
  selectAllRows: 'Select all rows',
  selectAllValues: 'Select all',
  selectRow: 'Select row',
  showAllColumns: 'Show all',
  sortAscending: 'Sort ascending',
  sortDescending: 'Sort descending',
  toolbarColumns: 'Columns',
  toolbarExport: 'Export',
  toolbarPrint: 'Print',
  toolbarRedo: 'Redo',
  toolbarUndo: 'Undo',
  undoneAnnouncement: 'Change undone',
  unpin: 'Unpin'
}

export const interpolate = (template: string, tokens: Record<string, string | number>): string =>
  template.replace(/\{(\w+)\}/g, (match: string, token: string) =>
    token in tokens ? String(tokens[token]) : match
  )
